import type { AudienceRequestStatus } from '@/api/channel/type'
import styled from '@emotion/styled'
import { Flex, Icon, Tag, Text } from '@collable/ui'

interface AudienceImageStatusProps {
  channelSettings: AudienceRequestStatus
  file: File | null
}

const STATUS_MAP = {
  PENDING: {
    label: '승인 대기 상태',
    color: 'warning',
  },
  ACCEPTED: {
    label: '승인 완료',
    color: 'success',
  },
  REJECTED: {
    label: '승인 거부',
    color: 'danger',
  },
} as const

const AudienceImageStatus = ({ channelSettings, file }: AudienceImageStatusProps) => {
  if (file)
    return (
      <Container justifyContent="center" gap={8} alignItems="center">
        <Icon name="checkCircle" iconSize={24} iconColor="statusPositive" />
        <Text size="body2" fontWeight="medium" ellipsis>
          {file.name}
        </Text>
      </Container>
    )

  if (!channelSettings) return null

  return (
    <TagContainer>
      <Tag type="solid" size="large" color={STATUS_MAP[channelSettings].color}>
        {STATUS_MAP[channelSettings].label}
      </Tag>
    </TagContainer>
  )
}

export default AudienceImageStatus

const Container = styled(Flex)`
  width: fit-content;
  margin-left: auto;
  height: 48px;
  max-width: 320px;
  padding: 0 16px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.line.lineNormal};
  background-color: ${({ theme }) => theme.common.commonWhite};
`

const TagContainer = styled.div`
  width: fit-content;
  margin-left: auto;
`
